// extracted by mini-css-extract-plugin
export default {"aurContainer":"styles_aurContainer__7KA82","aurNotFoundTypography":"styles_aurNotFoundTypography__wav2p"};